import { JSX, ChangeEvent, useCallback } from "react";
import { useTranslation } from "react-i18next";

import Checkbox from "@mui/material/Checkbox";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

import useListHeadInfo, { ListHeadInfo } from "lib/list/useListHeadInfo";

import { asTitle } from "utils/Utils";

import TrashTableRow from "./TrashTableRow";
import { TrashItem } from "./TrashTypes";

export type TrashTableProps = {
	items: Array<TrashItem>;
};

export default function TrashTable(
	props: Readonly<TrashTableProps>
): JSX.Element {
	const { t } = useTranslation();

	const listHeadInfo: ListHeadInfo = useListHeadInfo();

	const handleSelectAll = useCallback(
		(_event: ChangeEvent<HTMLInputElement>, checked: boolean): void =>
			listHeadInfo.selectAll(checked),
		[listHeadInfo]
	);

	return (
		<Table size="small">
			<TableHead>
				<TableRow>
					<TableCell padding="checkbox">
						<Checkbox
							aria-label="select all"
							checked={listHeadInfo.allSelected}
							indeterminate={listHeadInfo.someSelected}
							onChange={handleSelectAll}
						/>
					</TableCell>
					<TableCell>{asTitle(t("title"))}</TableCell>
					<TableCell>{asTitle(t("type"))}</TableCell>
					<TableCell>{asTitle(t("deletedOn"))}</TableCell>
					<TableCell>{asTitle(t("deletedBy"))}</TableCell>
				</TableRow>
			</TableHead>

			<TableBody>
				{props.items.map(item => (
					<TrashTableRow key={item.id} item={item} />
				))}
			</TableBody>
		</Table>
	);
}
